<template>
  <div class="content content-sp w-full grid grid-cols-2 gap-4 container-template-edit">
    <!-- Left -->
    <div class="left relative">
      <div class="absolute top-0 z-50 w-full px-8 py-2 menu-control">
        <div v-if="isCheckALlTemplate" class="flex justify-between items-center">
          <div>
            詳細指定する範囲を選択してください
          </div>
          <div class="right-0 flex gap-4 menu-check-draw">
            <div
                @click="selectEvent('square')"
                class="btn-template-detail"
                :class="[type == 'square' ? 'btn-template-detail-active' : '']"
            >
              <img src="@/assets/area.png" alt=""/>
            </div>
            <div
                @click="selectEvent('table')"
                class="btn-template-detail"
                :class="[type == 'table' ? 'btn-template-detail-active' : '']"
            >
              <img src="@/assets/table.png" alt=""/>
            </div>
            <div
                @click="selectEvent('checked')"
                class="btn-template-detail"
                :class="[type == 'checked' ? 'btn-template-detail-active' : '']"
            >
              <img src="@/assets/checked.png" alt=""/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="device === 'mobile' && isCheckALlTemplate" class="menu-control-sp top-0 py-2 absolute z-50">
        <div
            @click="selectEvent('square')"
            class="btn-template-detail"
            :class="[type == 'square' ? 'btn-template-detail-active' : '']"
        >
          <img src="@/assets/area.png" alt=""/>
        </div>
        <div
            @click="selectEvent('table')"
            class="btn-template-detail"
            :class="[type == 'table' ? 'btn-template-detail-active' : '']"
        >
          <img src="@/assets/table.png" alt=""/>
        </div>
        <div
            @click="selectEvent('checked')"
            class="btn-template-detail"
            :class="[type == 'checked' ? 'btn-template-detail-active' : '']"
        >
          <img src="@/assets/checked.png" alt=""/>
        </div>
      </div>
      <div class="z-50 flex justify-between items-center ">
        <div class="zoom-stickygroup-edit-left zoom-button rounded-full">
          <el-button @click="zoom(-1)" :disabled="zoomLevel < 0.1" type="info">
            -
          </el-button>
          <span class="text-white font-bold text-lg">
            {{ `${parseInt((zoomLevel * 10).toFixed() * 10)}%` }}
          </span>
          <el-button @click="zoom(1)" type="info">+</el-button>
        </div>
        <div class="zoom-stickygroup-edit-right flex gap-4">
          <div
              class="bg-white rounded-full p-3 shadow cursor-pointer"
              :class="[type == 'mouse-pointer' ? 'bg-active-btn' : '']"
              @click="selectEvent('mouse-pointer')"
          >
            <img src="@/assets/cursor.png" alt=""/>
          </div>
          <!--
          <div
            class="bg-white rounded-full py-3 px-2 shadow cursor-pointer"
            :class="[type == 'square' ? 'bg-active-btn' : '']"
            @click="selectEvent('square')"
          >
            <img src="@/assets/rectangle.png" alt="" />
          </div>
          -->
          <div
              class="bg-white rounded-full py-3 px-2 shadow cursor-pointer"
              v-if="is_instant || is_assignment"
              @click="drawer = true"
          >
            <font-awesome-icon icon="plus" class="mx-2"/>
          </div>
        </div>
      </div>
      <div
          class="bg-transparent h-full relative"
          style=""
          id="block-center"
          ref="bgImageOcr"
      >
        <div class="drag-drop mt-14" id="image-ocr" ref="imageOcr"
             :class="type != 'mouse-pointer' ? 'cursor-crosshair' : 'cursor-grab'"
        >
          <template>
            <v-stage
                ref="stage"
                :config="drrConfig"
                @mousedown="onMouseDown"
                @mousemove="onMouseMove"
                @click="onMouseUp"
                @touchstart="onMouseDown"
                @touchmove="onMouseMove"
                @touchend="onMouseUp"
                @tap="chooseActiveBox"
            >
              <v-layer ref="layer">
                <div v-for="(box, index) in drawBoxes" :key="index">
                  <v-rect
                      :config="{
                      name: box.name,
                      x: Math.min(box.x, box.x + box.width),
                      y: Math.min(box.y, box.y + box.height),
                      width: Math.abs(box.width),
                      height: Math.abs(box.height),
                      fill:
                        box.is_drawing || box.name === activeBox
                          ? 'rgb(177, 215, 182, 0.3)'
                          : 'rgb(165, 197, 222, 0.3)',
                      stroke:
                        box.is_drawing || box.name === activeBox
                          ? 'rgb(177, 215, 182)'
                          : 'rgb(165, 197, 222)',
                      strokeWidth: 1,
                      draggable: true,
                      is_box: true,
                      strokeScaleEnabled: false,
                      scaleX: box.scaleX,
                      scaleY: box.scaleY,
                      rotation: box.rotation || 0,
                    }"
                      :class="[box.name]"
                      v-if="box.name && !box.is_delete"
                      @transformend="handleTransformEnd"
                      @dragend="handleTransformEnd"
                  />
                </div>
                <v-transformer
                    ref="transformer"
                    :keepRatio="false"
                    anchorStroke="rgb(177, 215, 182)"
                    anchorFill="rgb(177, 215, 182)"
                    borderStroke="rgb(177, 215, 182)"
                    :anchorSize="15"
                    :rotateEnabled="false"
                />
              </v-layer>
            </v-stage>
          </template>
        </div>
      </div>

      <!-- MODAL TABLE -->
      <el-dialog
          :close-on-click-modal="false"
          title=""
          @closed="handleCloseTable"
          :visible.sync="isOpenTableModal"
      >
        <hr/>
        <div class="mt-6 mx-4">
          <span class="font-bold">表の向きは?</span>
          <div class="mt-6 mx-4">
            <div class="mt-1 custom__content__title">オプション1：行・列の最初のセルを選択して、システムはその行・列の残りのセルを自動的に検出する。
            </div>
            <div class="grid grid-cols-2 gap-4">
              <div>
                <p>
                  <el-radio v-model="radioTable" label="row">縮</el-radio>
                </p>
                <div class="mt-3 cursor-pointer" @click="radioTable = 'row'">
                  <table class="table-col">
                    <tr>
                      <td>A</td>
                      <td>%</td>
                      <td>¥</td>
                    </tr>
                    <tr>
                      <td>B</td>
                      <td>%</td>
                      <td>¥</td>
                    </tr>
                    <tr>
                      <td>C</td>
                      <td>%</td>
                      <td>¥</td>
                    </tr>
                  </table>
                </div>
              </div>
              <div>
                <p>
                  <el-radio v-model="radioTable" label="col">縮</el-radio>
                </p>
                <div class="mt-3 cursor-pointer" @click="radioTable = 'col'">
                  <table class="table-row">
                    <tr>
                      <td>A</td>
                      <td>B</td>
                      <td>C</td>
                    </tr>
                    <tr>
                      <td>%</td>
                      <td>%</td>
                      <td>%</td>
                    </tr>
                    <tr>
                      <td>¥</td>
                      <td>¥</td>
                      <td>¥</td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="mt-4 custom__content__title">オプション2：行・列の読み取る箇所を全て選択して、当該のセル数を入力してください。システムは入力したセル数通りに、選択した箇所を自動的に割り振る。
            </div>
            <div class="grid grid-cols-2 gap-4 mt-2">
              <div>
                <p>
                  <el-radio v-model="radioTable" label="rows">縮</el-radio>
                </p>
                <div class="mt-3 cursor-pointer" @click="radioTable = 'rows'">
                  <table class="table-col">
                    <tr>
                      <td>A</td>
                      <td>%</td>
                      <td>¥</td>
                    </tr>
                    <tr>
                      <td>B</td>
                      <td>%</td>
                      <td>¥</td>
                    </tr>
                    <tr>
                      <td>C</td>
                      <td>%</td>
                      <td>¥</td>
                    </tr>
                  </table>
                </div>
                <div class="flex mt-3 custom__input">
                  <div class="custom__title">セル数:</div>
                  <div class="custom__content">
                    <el-input class="custom__input__col" v-model="rowInput"  @keypress.native="handleNumber"
                              @blur.native="handleNumber"
                              @keyup.native="handleNumber" maxlength="3" :disabled="radioTable !== 'rows'"></el-input>
                  </div>
                </div>
              </div>
              <div>
                <p>
                  <el-radio v-model="radioTable" label="cols">縮</el-radio>
                </p>
                <div class="mt-3 cursor-pointer" @click="radioTable = 'cols'">
                  <table class="table-row">
                    <tr>
                      <td>A</td>
                      <td>B</td>
                      <td>C</td>
                    </tr>
                    <tr>
                      <td>%</td>
                      <td>%</td>
                      <td>%</td>
                    </tr>
                    <tr>
                      <td>¥</td>
                      <td>¥</td>
                      <td>¥</td>
                    </tr>
                  </table>
                </div>
                <div class="flex mt-3 custom__input">
                  <div class="custom__title">セル数:</div>
                  <div class="custom__content">
                    <el-input class="custom__input__col" v-model="columnInput"  @keypress.native="handleNumber"
                              @blur.native="handleNumber"
                              @keyup.native="handleNumber" maxlength="3" :disabled="radioTable !== 'cols'"></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <hr class="mb-4"/>
          <el-button @click="confirmDialogTable" class="btn-main">
            OK
          </el-button>
        </span>
      </el-dialog>
    </div>

    <!-- Right -->
    <div class="right bg-white relative">
      <div class="p-4 list-card">
        <p class="p-4 name-template">{{ template.name }}</p>
        <hr/>
        <div>
          <draggable
              :key="keyChange"
              v-model="template.boxes"
              @start="drag = true"
              @end="drag = false"
              :class="square ? 'card-container' : ''"
          >
            <div
                v-for="(box, index) in template.boxes"
                :key="box.id"
                :class="'card-' + box.name"
                @click="cardActive(box)"
            >
              <ValidationObserver ref="form">
              <Card
                  :is_assignment="is_assignment"
                  :assignmentBox="assignmentBox"
                  v-if="!box.is_delete"
                  @remove-box="removeBox(box)"
                  :is_instant="is_instant"
                  :inputs="inputs"
                  :template="template"
                  :index="index"
                  :box="box"
                  @box-value="setBoxValue"
                  :templateId="id"
                  :boxes="template.boxes"
                  :is_edit="true"
                  :class="activeBox === box.name ? 'selected-card' : ''"
                  :is-permission-all="isCheckALlTemplate"
                  @add-box="duplicateBox(box)"
              />
              </ValidationObserver>
            </div>
          </draggable>
        </div>

        <!-- Auto Detect -->
        <auto-detect
            :autoDetectVisible="autoDetectVisible"
            @set-detect-box="setDetectBox"
        >
        </auto-detect>

        <el-drawer
            title="The title"
            :visible.sync="drawer"
            direction="btt"
            :with-header="false"
            size="50%"
            :before-close="handleClose"
        >
          <div class="w-full h-full text-center flex justify-center pt-3">
            <div class="text-center w-1/2">
              <h3>新しい書類画像のファイルを選んでください。</h3>
              <div class="modal-content w-full">
                <ValidationObserver v-slot="{ invalid }">
                  <form>
                    <ValidationProvider
                        name="ファイル"
                        :rules="{
                        required: true,
                      }"
                        v-slot="{ errors }"
                        class=""
                    >
                      <el-button
                          @click="selectFile"
                          class="w-2/5 mt-4 mb-1"
                          type="info"
                      >
                        ファイルを選択
                      </el-button>
                      <div class="mt-4">
                        <span class="text-red-500">{{ errors[0] }}</span>
                      </div>
                      <input
                          type="file"
                          @change="chooseFile"
                          ref="selectFile"
                          class="hidden"
                      />
                    </ValidationProvider>

                    <div class="text-gray-400">{{ file_name }}</div>
                    <div v-if="is_instant" class="mt-3">
                      <el-button
                          @click="create"
                          class="w-2/5"
                          type="primary"
                          :disabled="invalid"
                      >
                        選択
                      </el-button>
                    </div>
                    <div v-if="is_assignment" class="mt-3">
                      <el-button
                          @click="updateAssignment(false)"
                          class="w-2/5"
                          type="primary"
                          :disabled="file_name == ''"
                      >
                        正解答のシートをアップロード
                      </el-button>
                    </div>
                  </form>
                </ValidationObserver>
              </div>
            </div>
          </div>
        </el-drawer>
      </div>

      <div class="btn-bot p-4 btn-bot-sp"  v-if="isCheckALlTemplate">
        <el-button
            @click="backPage"
            type="info"
            class="font-normal text-base py-2"
        >
          戻る
        </el-button>
        <el-button
            @click="saveTemplate(false)"
            type="primary"
            class="btn-main text-black hover:text-black font-normal text-base py-2"
        >
          テンプレートの定義を保存
        </el-button>
      </div>
      <el-dialog title="" :visible.sync="showPopupLeave" :show-close="true" class="ocr-dialog">
        <span>変更した内容を全て保存しますか？</span>
        <span slot="footer" class="dialog-footer">
        <el-button @click="nextPageRoute" class="ocr-button ocr-button-default">
          保存しないで完了
        </el-button>
        <el-button type="danger" @click="changeDataConfirm" class="btn-main ocr-button">
           保存
        </el-button>
      </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import fixHeightMain from "@/mixins/fixHeightMain.mixin";
import {mapActions, mapGetters, mapState} from "vuex";
import Card from "@/components/Card";
import _ from "lodash";
import AutoDetect from "@/components/AutoDetect";
import Panzoom from "@panzoom/panzoom";
import axios from "axios";
import draggable from "vuedraggable";
import {configSquareType} from "@/config/squareType";

const MIN_DRAWING_SIZE = 10;
const DEFAULT_ENGINE = 1;
const DEFAULT_CHARSET = 0;

export default {
  props: ["id", "is_instant", "is_assignment"],
  mixins: [fixHeightMain],
  components: {
    Card,
    AutoDetect,
    draggable,
  },
  data: function () {
    return {
      configSquareType,
      squareType: 1,
      drawer: false,
      isOpenTableModal: false,
      radioTable: "row",
      events: "",
      menus: [
        {
          name: "ハンド",
          icon: "mouse-pointer",
          is_instant: true,
        },
        {
          name: "読取範囲の指定",
          icon: "square",
          is_instant: true,
        },
        // {
        //   name: '注文書の自動読取範囲検出',
        //   icon: 'eye',
        //   is_instant: true,
        // }
      ],
      type: "",
      template: {
        // Template data
        boxes: [],
      },
      inputs: [
        {type: "number", name: "width"},
        {type: "number", name: "height"},
      ],
      square: false,
      isChange: false,
      imgWidth: 0,
      imgHeight: 0,
      img: {},
      hasBoxTitleIsEmpty: false,
      hasErrorValidate: false,
      hasDuplicateTitle: false,
      autoDetectVisible: false,
      zoomLevel: 1,
      process: 0,
      intervalId: "",
      batch: {},
      file_name: "",
      drrConfig: {
        width: 0,
        height: 0,
      },
      activeBox: "",
      showPopupLeave: false,
      isDrawing: false,
      nextRoute: null,
      drawBoxes: [], // List draw box
      assignmentBox: {}, // Assignment box to use orc
      count: 0,
      startEvent: false,
      columnInput: null,
      rowInput: null,
      close: false,
      keyChange: 0,
    };
  },
  computed: {
    ...mapState({
      detectList: (state) => state.detect.detects,
      autoDetectResult: (state) => state.detect.auto_detects,
      engineList: (state) => state.engine.engines,
      device: (state) => state.device.device
    }),
    ...mapGetters("auth", ["isCheckALlTemplate"]),
  },
  watch: {
    template: {
      deep: true,
      handler: function () {
        this.validateTemplate();
      },
    },
    square(newValue, oldValue) {
      if (!newValue && newValue !== oldValue) {
        this.handleSquareModeOff();
      }
    }
  },
  methods: {
    ...mapActions("template", [
      "getTemplate",
      "storeTemplateBox",
      "createTemplate",
      "saveTemplateAssignment",
    ]),
    ...mapActions(["loading"]),
    handleCloseTable() {
      this.isOpenTableModal = false
      if (!this.close) {
          this.type = "mouse-pointer";
          this.squareType = 1;
      }
      this.close = false;
    },
    handleNumber(event) {
      if (this.inputValue !== null && this.inputValue instanceof String) {
        this.inputValue = this.inputValue.toString().replace(/[^\d].+/, '')
      }
      if ((event.which < 48 || event.which > 57)) {
        event.preventDefault()
      }
    },
    handleClose(done) {
      this.$confirm(`テンプレートの作成をキャンセルしますか？`, {
        confirmButtonText: "はい",
        cancelButtonText: "いいえ",
      })
          .then(() => {
            done();
          })
          .catch(() => {
          });
    },

    backPage() {
      this.$router.push({name: "templates"});
    },

    selectFile: function () {
      this.$refs.selectFile.click();
    },
    create: async function () {
      let formData = new FormData();
      this.template.collection_id = 3;
      this.template.name = "test-ocr";
      for (let key in this.template) {
        formData.append(key, this.template[key]);
      }
      let response = await this.createTemplate(formData);
      if (response) {
        this.$router.push({
          name: "test-ocr",
          params: {
            id: response.id,
          },
        });
        this.isChange = false;
        this.$router.go();
      }
    },
    chooseFile: function (e) {
      let files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.template.upload_file = files[0];
      this.file_name = this.template.upload_file.name;
    },
    gotoListTemplate: function () {
      this.$router.push({
        name: "templates",
      });
    },
    validateTemplate() {
      this.isChange = true;
      this.hasErrorValidate = false;
      this.hasBoxTitleIsEmpty = false;
      this.hasDuplicateTitle = false;

      let box = null;
      for (let i in this.template.boxes) {
        box = this.template.boxes[i];
        if ((!box.title || ((Number(box.box_type) === configSquareType.tableRow || Number(box.box_type) === configSquareType.tableCol) && box.is_split && (!box.n_lines || box.n_lines < 2)))  && !box.is_delete) {
          this.hasBoxTitleIsEmpty = true;
          break;
        }
      }

      let titleArr = this.template.boxes
          .filter((item) => {
            return !item.is_delete;
          })
          .map((item) => {
            return item.title;
          });

      this.hasDuplicateTitle = titleArr.some(function (item, idx) {
        return titleArr.indexOf(item) !== idx;
      });

      if (this.hasBoxTitleIsEmpty || this.hasDuplicateTitle) {
        this.hasErrorValidate = true;
      }
    },
    sortBoxes() {
      this.template.boxes.sort((a, b) => {
        return a.order - b.order;
      });
    },
    setSortBoxes() {
      this.template.boxes.map((item, index) => {
        item.order = index + 1;
        return item;
      });
    },
    setImage: function (imageUrl) {
      this.img = new Image();
      this.img.src = imageUrl;

      const self = this;
      this.img.onload = function () {
        self.imgWidth = self.img.width;
        self.imgHeight = self.img.height;

        let imageOcr = document.getElementById("image-ocr");
        if (imageOcr) {
          imageOcr.style.width = self.imgWidth + "px";
          imageOcr.style.height = self.imgHeight + "px";
          imageOcr.style.backgroundImage = `url(${imageUrl})`;
          imageOcr.style.backgroundRepeat = "no-repeat";
        }

        self.fetchBoxes();

        let dragDrop = document.getElementsByClassName("drag-drop")[0];
        if (dragDrop) {
          dragDrop.style.width = self.imgWidth + "px";
          dragDrop.style.height = self.imgHeight + "px";
        }
        self.initZoom();
        self.zoom(0);

        // Set canvas frames
        self.drrConfig.width = self.imgWidth;
        self.drrConfig.height = self.imgHeight;

        self.isChange = false;
      };
    },
    fetchBoxes() {
      if (!this.is_assignment) {
        this.$set(this, "drawBoxes", []);
        this.drawBoxes = this.template.boxes.map((box) => {
          let drawBox = {};
          drawBox.x = box.start_x * this.imgWidth;
          drawBox.y = box.start_y * this.imgHeight;
          drawBox.width = box.end_x * this.imgWidth - drawBox.x;
          drawBox.height = box.end_y * this.imgHeight - drawBox.y;
          drawBox.name = box.name = this.generateBoxName();
          drawBox.scaleX = 1;
          drawBox.scaleY = 1;
          drawBox.rotation = 0;
          return drawBox;
        });
      }

      this.$store.commit("SET_BOXES", this.template.boxes);
    },
    fetchTemplate: async function (id) {
      let res = await this.getTemplate(id);
      if (res && res !== "アクセス拒否。" && res.message !== 'テンプレートが存在しません') {
        this.template = _.cloneDeep(res);
        this.sortBoxes();
        this.template.url =
            process.env.VUE_APP_BACK_END_URL + "/" + this.template.url;
        this.template.ground_truth_image =
            process.env.VUE_APP_BACK_END_URL +
            "/" +
            this.template.ground_truth_image;
        if (this.is_assignment) {
          this.setImage(this.template.ground_truth_image);
        } else {
          this.setImage(this.template.url);
        }
        this.loading(false);
      } else {
          this.$router.push({ name: "templates"})
      }
    },
    runInstanceOCR: async function () {
      this.loading(true);
      this.saveTemplate(true);
      const self = this;
      let formData = new FormData();

      // Todo
      formData.append("name", this.template.name);
      const config = {responseType: "blob"};
      let file = await axios.get(this.template.url, config).then((response) => {
        return new File([response.data], "temp.png");
      });
      formData.append("upload_files", file);

      self.batch = await self.$store.dispatch("ocr/runTemplate", {
        formData: formData,
        id: this.template.id,
      });

      self.getTemplateStatus(self.batch);
      self.intervalId = setInterval(() => {
        self.getTemplateStatus(self.batch);
      }, 5000);
    },
    getTemplateStatus: async function (batch) {
      let self = this;
      let response = await self.$store.dispatch("ocr/getTemplateStatus", {
        batch_id: batch.template_batch_id,
        id: batch.template_id,
      });
      self.process = (response.n_processed / response.n_files) * 100;
      if (self.process == 100) {
        clearInterval(self.intervalId);
        self.loading(false);
        self.isChange = false;
        self.$router.push({
          path: `/confirm_result/${self.batch.template_id}/batch/${self.batch.template_batch_id}`,
        });
      }
      return response;
    },
    zoom(level) {
      this.square = false;
      this.type = "mouse-pointer";
      if (level == 0) {
        let zoomWidth = this.$refs.bgImageOcr.offsetWidth / this.imgWidth;
        let zoomHeight = this.$refs.bgImageOcr.offsetHeight / this.imgHeight;
        this.zoomLevel = Math.min(zoomWidth, zoomHeight);
      } else {
        this.zoomLevel += level / 10;
      }
      if (!this.panzoom) {
        this.initZoom();
      }
      this.panzoom.setOptions({cursor: "default"});
      this.panzoom.zoom(this.zoomLevel, {animate: true});
    },
    initZoom() {
      this.square = false;
      this.type = "";
      if (!this.panzoom) {
        this.panzoom = Panzoom(document.getElementById("image-ocr"), {
          maxScale: 5,
          disablePan: false,
          cursor: "default",
          origin: "top left",
          setTransform: (elem, {x, y, scale}) => {
            elem.style.transform = `scale(${scale}) translate(${x}px, ${y}px)`;
          },
          handleStartEvent: (event) => {
            if (this.square) {
              throw "For handle events create box";
            } else {
              event.stopPropagation();
              event.preventDefault();
            }
          },
        });
      }
    },
    handleSquareModeOff() {
      this.removeActiveBox();
    },
    async removeBox(selectedBox) {
      let box = this.template.boxes.find(
          (item) => item.name === selectedBox.name
      );
      box.is_delete = true;
      this.validateTemplate();
      _.remove(this.drawBoxes, (item) => item.name === selectedBox.name);
      if (box.name === this.activeBox) this.removeActiveBox();
      this.$forceUpdate();
      if (this.$refs.form) {
          for (let i = 0; i < this.$refs.form.length; i++) {
              await this.$refs.form[i].validate()
          }
      }
    },
    setDetectBox: function (autoDetectResult) {
      for (let detectField in autoDetectResult) {
        let detectFieldObj = this.detectList.find(function (object) {
          return detectField == object.id;
        });
        let title = detectFieldObj.title;
        const self = this;
        autoDetectResult[detectField] &&
        autoDetectResult[detectField].forEach(function (autoDetectRs, index) {
          let [start_x, start_y, end_x, end_y] = autoDetectRs.position.split(
              ","
          );
          let boxTitle = title;
          if (index) boxTitle += index;
          const name = self.generateBoxName();
          self.template.boxes.push({
            start_x: start_x / self.imgWidth,
            start_y: start_y / self.imgHeight,
            end_x: end_x / self.imgWidth,
            end_y: end_y / self.imgHeight,
            title: boxTitle,
            charset: DEFAULT_CHARSET,
            engine: DEFAULT_ENGINE,
            name,
          });

          self.drawBoxes.push({
            x: start_x,
            y: start_y,
            width: end_x - start_x,
            height: end_y - start_y,
            name,
          });
        });
      }
    },
    getDrawingBox() {
      return this.drawBoxes.find((item) => item.is_drawing === true) || {};
    },
    generateBoxName() {
      return `drr-item-${Date.now()}-${Math.floor(
          100000 + Math.random() * 900000
      )}`;
    },
    onMouseDown(e) {
      // Choose active box when clicked
      if (this.count === 1 || !this.startEvent) {
        return false
      }
      this.chooseActiveBox(e);
      // Prevent draw override other box
      if (e.target.attrs.is_box) return false;
      // Prevent drawing when the box active
      if (this.activeBox) return false;
      this.isDrawing = true;
      const currentPosition = this.$refs.stage.getNode().getPointerPosition();

      return this.createBox({
        x: currentPosition.x,
        y: currentPosition.y,
        is_drawing: true,
      });
    },
    onMouseMove() {
      // No drawing - skipping
      if (!this.isDrawing) return false;
      const currentPosition = this.$refs.stage.getNode().getPointerPosition();
      let drawingBox = this.getDrawingBox();
      drawingBox.width = currentPosition.x - drawingBox.x;
      drawingBox.height = currentPosition.y - drawingBox.y;
    },
    onMouseUp() {
      // No drawing - skipping
      if (!this.isDrawing) return true;
      this.count++
      if (this.count < 2) {
        return false
      }
      this.count = 0
      // Reset drawing
      this.isDrawing = false;
      let drawingBox = this.getDrawingBox();

      // Remove the drawing box when it too small
      if (
          Math.abs(drawingBox.height) < MIN_DRAWING_SIZE ||
          Math.abs(drawingBox.width) < MIN_DRAWING_SIZE
      ) {
        _.remove(this.drawBoxes, ({name}) => name === drawingBox.name);
      } else {
        // Finish drawing
        delete drawingBox.is_drawing;
        this.handleDrawBoxUpdate(drawingBox.name);
        // Active box after draw is finished
        this.selectAndScrollCard(drawingBox.name);
      }
      this.$forceUpdate();
    },
    chooseActiveBox(e) {
      // clicked on stage - clear selection
      if (e.target === e.target.getStage()) {
        this.activeBox = "";
        this.updateTransformer();
        return;
      }

      // clicked on transformer - do nothing
      const clickedOnTransformer =
          e.target.getParent().className === "Transformer";
      if (clickedOnTransformer) return false;

      // Find clicked box by its name
      const name = e.target.name();
      const box = this.drawBoxes.find((r) => r.name === name);
      let activeBox = "";
      if (box) activeBox = name;
      this.selectAndScrollCard(activeBox);
    },
    selectAndScrollCard(name) {
      this.activeBox = name;
      this.updateTransformer();
      setTimeout(() => {
        let selectedCard = document.querySelector(`.card-${name}`);
        if (selectedCard)
          selectedCard.scrollIntoView({behavior: "smooth", block: "start"});
      }, 100);
    },
    removeActiveBox() {
      this.activeBox = "";
      this.updateTransformer();
    },
    onBoxDrag(e) {
      // Off this feature
      let boxNode = e.target;
      let boxX = boxNode.x();
      let boxY = boxNode.y();
      let boxWidth = Math.abs(boxNode.width());
      let boxHeight = Math.abs(boxNode.height());
      let boxScaleX = boxNode.scaleX();
      let boxScaleY = boxNode.scaleY();

      if (boxX < 0 || boxY < 0) {
        if (boxX < 0) boxNode.x(0);
        if (boxY < 0) boxNode.y(0);
      }

      if (boxX + boxWidth * boxScaleX > this.drrConfig.width) {
        boxNode.x(this.drrConfig.width - boxWidth * boxScaleX);
      }

      if (boxY + boxHeight * boxScaleY > this.drrConfig.height) {
        boxNode.y(this.drrConfig.height - boxHeight * boxScaleY);
      }
    },

    handleTransformEnd(e) {
      // Shape is transformed, let us save new attrs back to the node
      // Find element in our state
      let box = this.drawBoxes.find(({name}) => name === this.activeBox);
      box.x = e.target.x();
      box.y = e.target.y();
      box.width = e.target.width();
      box.height = e.target.height();
      box.scaleX = e.target.scaleX();
      box.scaleY = e.target.scaleY();
      box.rotation = e.target.rotation();
      delete box.is_new;
      this.handleDrawBoxUpdate(this.activeBox);
    },
    updateTransformer() {
      // do nothing if selected node is already attached
      // here we need to manually attach or detach Transformer node
      const transformerNode = this.$refs.transformer.getNode();
      const stage = transformerNode.getStage();

      const selectedNode = stage.findOne("." + this.activeBox);
      if (selectedNode === transformerNode.node()) return false;

      if (selectedNode) {
        // attach to another node
        transformerNode.nodes([selectedNode]);
      } else {
        // remove transformer
        transformerNode.nodes([]);
      }
    },

    handleDrawBoxUpdate(boxName) {
      if (!boxName) return false;
      const updatedBox = this.drawBoxes.find(({name}) => name === boxName);
      let x = updatedBox.x;
      let y = updatedBox.y;
      let width = Math.abs(updatedBox.width) || MIN_DRAWING_SIZE;
      let height = Math.abs(updatedBox.height) || MIN_DRAWING_SIZE;
      let scaleX = Math.abs(updatedBox.scaleX) || 1;
      let scaleY = Math.abs(updatedBox.scaleY) || 1;

      // Transform to right - top
      if (
          (!updatedBox.is_new &&
              updatedBox.rotation === 0 &&
              updatedBox.scaleY < 0) ||
          (updatedBox.is_new && updatedBox.height < 0 && updatedBox.width > 0)
      ) {
        scaleY = -scaleY;
      }

      // Transform to left - bottom
      if (
          (!updatedBox.is_new &&
              updatedBox.rotation < 0 &&
              updatedBox.scaleY < 0) ||
          (updatedBox.is_new && updatedBox.height > 0 && updatedBox.width < 0)
      ) {
        scaleX = -scaleX;
      }

      // Transform to left - top
      if (
          (!updatedBox.is_new &&
              Math.abs(updatedBox.rotation) === 180 &&
              updatedBox.scaleY > 0) ||
          (updatedBox.is_new && updatedBox.height < 0 && updatedBox.width < 0)
      ) {
        scaleX = -scaleX;
        scaleY = -scaleY;
      }

      const x1 = x / this.imgWidth;
      const y1 = y / this.imgHeight;
      const x2 = (x + width * scaleX) / this.imgWidth;
      const y2 = (y + height * scaleY) / this.imgHeight;

      const start_x = Math.min(x1, x2);
      const end_x = Math.max(x1, x2);
      const start_y = Math.min(y1, y2);
      const end_y = Math.max(y1, y2);

      // For assignment box
      if (this.is_assignment) {
        this.assignmentBox = {start_x, start_y, end_x, end_y};
      }
      const n_lines = this.radioTable === 'rows' ? this.rowInput : (this.radioTable === 'cols' ? this.columnInput : 1)
      const col = (this.radioTable === 'rows' || this.radioTable === 'cols')
      if (!this.is_assignment) {
        let templateBox = this.template.boxes.find(
            ({name}) => name === boxName
        );
        if (!templateBox) {
          this.template.boxes.push({
            start_x,
            start_y,
            end_x,
            end_y,
            name: updatedBox.name,
            charset: DEFAULT_CHARSET,
            engine: DEFAULT_ENGINE,
            title: this.is_instant
                ? Math.random()
                    .toString(36)
                    .substr(2, 12)
                : "",
            box_type: this.squareType,
            n_lines: n_lines,
            is_split: col
          });
        } else {
          templateBox.start_x = start_x;
          templateBox.start_y = start_y;
          templateBox.end_x = end_x;
          templateBox.end_y = end_y;
        }
      }
    },

    selectEvent: function (icon) {
      this.rowInput = null
      this.columnInput = null
      this.radioTable = 'row'
      this.type = icon;
      this.square = false;
      if (!this.panzoom) {
        this.initZoom();
      }
      if (icon === "square") {
        this.startEvent = true
        this.square = true;
        this.squareType = this.configSquareType.square;
        if (this.panzoom) {
          this.panzoom.setOptions({cursor: "default"});
        }
      }
      if (icon === "table") {
        this.startEvent = true
        this.isOpenTableModal = true;
        this.squareType = this.configSquareType.tableRow;
      }
      if (icon === "checked") {
        this.startEvent = true
        this.square = true;
        this.squareType = this.configSquareType.checked;
        if (this.panzoom) {
          this.panzoom.setOptions({cursor: "default"});
        }
      }
      if (icon === "eye") {
        this.isChange = false;
        this.autoDetectVisible = !this.autoDetectVisible;
      }

      if (icon === "mouse-pointer") {
        this.startEvent = false
        if (this.panzoom) {
          this.panzoom.setOptions({cursor: "default"});
        }
      }
    },

    confirmDialogTable() {
      this.close = true;
      this.isOpenTableModal = false;
      if (this.radioTable === "row" || this.radioTable === "rows") {
        this.squareType = this.configSquareType.tableRow;
      } else {
        this.squareType = this.configSquareType.tableCol;
      }
      this.square = true;
      if (this.panzoom) {
        this.panzoom.setOptions({cursor: "grab"});
      }
    },

    createBox(data) {
      const n_lines = this.radioTable === 'rows' ? this.rowInput : (this.radioTable === 'cols' ? this.columnInput : null)
      const col = (this.radioTable === 'rows' || this.radioTable === 'cols')
      let box = {
        x: data.x,
        y: data.y,
        width: data.width || 0,
        height: data.height || 0,
        name: this.generateBoxName(),
        is_drawing: data.is_drawing,
        n_lines: n_lines,
        is_split: col,
        is_new: true,
        ground_truth: ''
      };

      if (this.is_assignment) {
        this.drawBoxes = [];
      }

      this.drawBoxes.push(box);
    },
    setBoxValue: function (payload) {
      this.template.boxes[payload.index] = payload.box;
    },
    updateAssignment: async function (keep_loading = false) {
      this.loading(true);
      let formData = new FormData();
      formData.append("name", this.template.name);
      formData.append("id", this.template.id);
      formData.append("ground_truth_image", this.template.upload_file);
      // Call API
      let response = await this.saveTemplateAssignment(formData);
      let ground_truth_image_url =
          process.env.VUE_APP_BACK_END_URL + "/" + response.ground_truth_image;
      this.setImage(ground_truth_image_url);
      this.drawer = false;

      if (!keep_loading) {
        this.loading(false);
        this.isChange = false;
      }
    },
    saveTemplate: async function (keep_loading = false) {
      let valid = true
      if (this.$refs.form) {
        for (let i = 0; i < this.$refs.form.length; i++) {
          const isValid = await this.$refs.form[i].validate()
          if (!isValid) {
            valid = false
          }
        }
      }
      if (valid) {
        this.loading(true);
        this.setSortBoxes();
        let response = await this.storeTemplateBox({
          boxes: JSON.stringify(
              JSON.stringify({
                boxes: this.template.boxes,
              }).replace(/\\"/g, '"')
          ),
          id: this.template.id,
        });
        if (response.message) {
          this.loading(false);
          this.backPage()
          return;
        }
        if (response) {
          this.template.boxes = response;
          this.fetchBoxes();
          this.removeActiveBox();
        }

        if (!keep_loading) {
          this.loading(false);
        }
        setTimeout(() => {
          this.isChange = false;
        });
      }

    },
    cardActive(box) {
      if (!this.square || this.is_assignment) return false;
      this.activeBox = box.name;
      this.updateTransformer();
    },
    async changeDataConfirm() {
      if (!this.hasErrorValidate) {
          await this.saveTemplate()
          this.isChange = false
          this.nextRoute()
      } else {
          await this.saveTemplate()
      }
      this.showPopupLeave = false
    },
    nextPageRoute() {
      this.showPopupLeave = false
      this.isChange = false
      return this.nextRoute()
    },

    async duplicateBox(selectedBox) {
      const findBox = this.template.boxes.find(
          (item) => item.name === selectedBox.name
      );
      const index = this.template.boxes.findIndex(
          (item) => item.name === selectedBox.name
      );
      const drawBox = this.drawBoxes.find(
          (item) => item.name === selectedBox.name
      );
      const box = {
        x: drawBox.x,
        y: drawBox.y,
        width: drawBox.width || 0,
        height: drawBox.height || 0,
        name: this.generateBoxName(),
        is_drawing: drawBox.is_drawing,
        n_lines: drawBox.n_lines,
        is_split: drawBox.is_split,
        ground_truth: '',
        is_new: true
      };
      this.drawBoxes.push(box);
      const boxes = {
        start_x: findBox.start_x,
        start_y: findBox.start_y,
        end_x: findBox.end_x,
        end_y: findBox.end_y,
        name: box.name,
        charset: findBox.charset,
        engine: findBox.engine,
        title: findBox.title,
        box_type: findBox.box_type,
        n_lines: findBox.n_lines,
        is_split: findBox.is_split,
        ground_truth: findBox.ground_truth,
      }
      const data = [...this.template.boxes];
      const newData = [
          ...data.slice(0, index + 1),
          boxes,
          ...data.slice(index + 1)
      ];
      this.template.boxes = [...newData];
      this.keyChange = this.keyChange === 1 ? 0 : 1;
      if (this.$refs.form) {
        for (let i = 0; i < this.$refs.form.length; i++) {
          await this.$refs.form[i].validate()
        }
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    let self = this;
    if (self.isChange && this.isCheckALlTemplate) {
      // const answer = window.confirm(
      //   "変更を保存しましたか？ 保存していない変更はすべて失われるのでご注意ください。"
      // );
      // if (answer) {
      //   self.isChange = false;
      //   next();
      // } else {
      //   next(false);
      // }
      this.showPopupLeave = true
      this.nextRoute = next
    } else {
      self.isChange = false;
      next();
    }
  },
  mounted() {
    self.isChange = false;
  },
  created() {
    if ((this.is_instant || this.is_assignment) && this.menus[2]) {
      this.menus[2].is_instant = false;
    }
    this.loading(true);
    const self = this;
    window.onbeforeunload = function () {
      if (self.isChange) {
        return "Changes won't be saved when leaving?";
      }
      self.isChange = false;
    };

    if (this.id !== 0) {
      self.fetchTemplate(this.id);
    } else {
      self.loading(false);
    }
  },
};
</script>

<style scoped="scoped">
.drag-drop {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.button-sticky-group {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60px;
}

.zoom-stickygroup-edit-left {
  width: 50px;
  position: absolute;
  bottom: 24px;
  left: 24px;
  z-index: 1999;
}

.zoom-stickygroup-edit-right {
  position: absolute;
  bottom: 34px;
  right: 24px;
  z-index: 1999;
}

#block-center {
  overflow-y: scroll;
  background-color: #abb7ca;
}

.zoom-button {
  font-size: 16px;
  width: 164px;
  height: 48px;
  left: 24px;
  bottom: 24px;
  background: #00000080;
  display: flex;
  justify-content: space-between;
  transform: unset;
  align-items: center;
  padding: 10px;
}

.zoom-button button {
  background: none;
  border: none;
  padding: 8px;
  font-size: 160%;
}

.selected-card >>> .el-card {
  background: #b1d7b6;
}

.card-container {
  cursor: pointer;
}

.left {
  background: #e0e5ed;
  border: 1px solid #ffffff;
}

.content {
  min-height: calc(100vh - 110px);
}

.right {
  height: calc(100vh - 111px);
  overflow-y: auto;
  position: relative;
}

.right::-webkit-scrollbar {
  display: none;
}

.btn-bot {
  position: sticky;
  bottom: 0;
  right: 0;
  background: #ffffff;
  width: 100%;
  text-align: right;
}

.list-card {
  min-height: calc(100% - 74px);
}

.el-button--info.is-disabled,
.el-button--info.is-disabled:active,
.el-button--info.is-disabled:focus,
.el-button--info.is-disabled:hover {
  color: #fff;
  background: none;
  border: none;
}

.bg-active-btn {
  background: #fdb92c;
}

.btn-template-detail {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 38px;
  background: none;
  border: 1.5px solid #fdb92c;
  border-radius: 4px;
}

.btn-template-detail:hover {
  background: #ffaa0010;
  border: 1.5px solid #ffaa00;
}

.table,
table th,
table td {
  border: 1px solid black;
}

table td {
  font-weight: 700;
  text-align: center;
  width: 40px;
  height: 40px;
  color: black;
}

.table-col td:first-child {
  background: #fdb92c;
}

.table-row tr:first-child {
  background: #fdb92c;
}

.menu-control {
  background: #abb7ca;
}

.cursor-crosshair {
  cursor: crosshair !important;
}

.cursor-grab {
  cursor: grab !important;
}
/deep/.el-dialog {
  width: 480px;
  padding: 0 20px;
  max-width: 100%;
}
.el-dialog__wrapper {
  padding: 15px;
}
/*.table-col, .table-row {*/
/*  width: 100%;*/
/*}*/
.custom__input {
  display: flex;
  flex-wrap: wrap;
  width: 120px;
  align-items: center;
}
.custom__title {
  width: 40px;
  font-weight: bold;
  font-size: 14px;
  margin-right: 10px;
}
.custom__content {
  width: 70px;
}
.custom__input__col > /deep/.el-input__inner {
  border-color: black;
}
.custom__content__title {
  font-size: 12px;
  font-weight: bold;
}
@media screen and (max-width: 1024px){
  .custom__content {
    width: 40px;
  }
  .ocr-home {
    padding: 0 !important;
  }
  .content-sp {
    display: flex;
    flex-wrap: wrap;
  }
  .left {
    height: 600px;
    width: 100%;
  }
}
@media screen and (max-width: 820px) {
  .menu-check-draw {
    display: none;
  }
  .menu-control-sp {
    right: 0;
    padding-right: 16px;
    padding-left: 16px;
    line-height: 20px;
  }
  .menu-control-sp > .btn-template-detail {
    margin-bottom: 10px;
  }
  .right {
    overflow: unset;
  }
  .list-card {
    min-height: calc(100vh - 674px);
  }
  .right {
    height: calc(100vh - 674px);
  }
  .custom__content {
    width: 40px;
  }
}

@media screen and (max-width: 767px){
  .left {
    height: 350px;
    width: 100%;
  }
  .list-card {
    min-height: calc(100vh - 424px);
  }
  .right {
    height: calc(100vh - 424px);
  }
  .right {
    width: 100%;
    max-width: 100%;
    overflow: unset;
  }
  .list-card{
    padding: 16px;
  }
  .name-template {
    padding: 8px 0;
  }
  .card-item {
    padding: 15px 0;
  }
  .zoom-button {
    width: 140px;
    height: 40px;
    font-size: 10px;
    bottom: 16px;
  }
  .zoom-button button {
    padding: 4px;
  }
  .zoom-stickygroup-edit-right {
    bottom: 16px;
    right: 12px;
  }
  .btn-bot-sp > button{
    border-radius: 100px;
  }
}
/*table {*/
/*  min-width: 120px;*/
/*}*/
</style>
